
define('text!templates/modules/setting/business/payment/payment-update-method-notice.html',[],function () { return '<span class="sl-icon-exclamation"></span>\n<span>{{#t}}payment:update_method_notice{{/t}}</span>\n';});

